export const DAY = 24 * 60 * 60 * 1000;

export const getStartAndEndOfWeek = (selectedDate) => {
  const jsDate = new Date(selectedDate);
  const dayOfWeek = jsDate.getDay();
  const jsStartOfWeek =
    jsDate.getTime() - (dayOfWeek ? dayOfWeek - 1 : 6) * DAY;
  const startOfWeek = dateOf(jsStartOfWeek);
  const endOfWeek = dateOf(jsStartOfWeek + DAY * 7);
  let model = {
    startOfWeek,
    endOfWeek,
  };
  return model;
};

export const dateOf = (d) => {
  if (!d) return "";
  if (typeof d === "string") return d.substring(0, 10);
  if (typeof d === "number") return dateOf(new Date(d));
  if (d.toISOString) return dateOf(d.toISOString());
  return d;
};

export const DateToday = (selectedDate) => {
  const jsDate = new Date(selectedDate);
  const dayOfWeek = jsDate.getDay() - 2;
  const jsStartOfWeek =
    jsDate.getTime() - (dayOfWeek ? dayOfWeek - 1 : 6) * DAY;
  const todayDate = dateOf(jsStartOfWeek + DAY);

  return todayDate;
};

export function getAcitivtyValue(statementCode, array) {
  let findElement;
  if (statementCode != undefined && array != undefined) {
    if (array.length != 0) {
      let newElement = array?.activityStatements?.find(
        (element) => element.statementCode == statementCode
      );
      findElement = newElement?.value;
    }
  } else {
    findElement = "error";
  }
  return findElement;
}

export function getChildActivityValue(statementCode, array) {
  const statementCodeActivity = array?.activityStatements?.find(
    (element) => element.statementCode == statementCode
  );

  const activityVallue =
    statementCodeActivity?.value != undefined ||
    statementCodeActivity?.value != null
      ? statementCodeActivity.value
      : "";
  return activityVallue;
}

export function roleHelper(dataRole, salesPersonRole) {
  const myArray = dataRole.split(",");
  const returnValue = salesPersonRole.includes(myArray[myArray.length - 1]);
  return returnValue
}
